import * as Sentry from "@sentry/react";
import { YieldType } from "../../globalTypes";
import { InsertUpdatedSecurityValues } from "../../store/types";
import { broadcastEditedDataByAllocation } from "./broadcastEditedDataByAllocation";

export interface ProcessDataProducerEventArgs {
  context: Excel.RequestContext;
  isOnChanged?: boolean;
  range: Excel.Range;
  worksheet: Excel.Worksheet;
  updatedValue?: number;
  updatedValueYieldType?: YieldType;
  onSetQuoteFeedAsNone: ({ securityProducerId }: { securityProducerId: string }) => void;
  onSaveSecurityInStaging: (data: InsertUpdatedSecurityValues) => Promise<void>;
}

export async function processDataProducerEvent(props: ProcessDataProducerEventArgs) {
  const { isOnChanged, range } = props;

  if (range.values[0].length > 1) {
    Sentry.captureException(
      new Error('Multiple cells changed, event not supported', { cause: { rangeValues: range.values } })
    );
    return;
  }

  if (isOnChanged) {
    const editedFormula = range.formulas[0][0];

    if (editedFormula[0] === "=") {
      return;
    }
  }

  const editedColumn = range.columnIndex;
  const editedRow = range.rowIndex;

  await broadcastEditedDataByAllocation({
    ...props,
    editedColumn,
    editedRow,
  });
}
